import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Text } from '@aws-amplify/ui-react';
import PageBaseNoSignIn from '@components/pages/PageBaseNoSignIn';
import { Button, Grid, Link } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { FacilityState } from '@atom/FacilityState';

const GroupNewCompletePage = () => {
  const facility = useRecoilValue(FacilityState);
  const { facilityId } = facility;
  const navigate = useNavigate();

  return (
    <PageBaseNoSignIn title="ご指定のメールアドレスに団体登録URLを送付しました。">
      <Grid container spacing={2}>
        <Grid item xs={12} ml={2} mr={2} mt={2}>
          <Text
            variation="primary"
            as="p"
            lineHeight="1.5em"
            fontWeight={400}
            fontSize="1em"
            fontStyle="normal"
            textDecoration="none"
            width="100%"
          >
            メールからURLをクリックし、本会員登録にお進みください。
            <br />
            <br />
            <Link href="https://aomori-arena.jp/application_form/" target="_blank" rel="noopener noreferrer">
              メールが届かない場合はこちら
            </Link>
          </Text>
        </Grid>
        <Grid item xs={12} ml={2} mr={2} mt={2}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              navigate(`/c001/arealist?facilityId=${facilityId}`);
            }}
          >
            施設TOPへ
          </Button>
        </Grid>
      </Grid>
    </PageBaseNoSignIn>
  );
};

export default GroupNewCompletePage;
